<template>
    <div class="sample-order">
        <div class="subtitle">
            <div class="sub-left">订购列表</div>
            <div class="sub-right">
                <a-input v-model="searchKey" placeholder="请输入" />
                <a-button @click="clear">清除</a-button>
                <a-button type="primary" @click="getList">查询</a-button>
            </div>
        </div>

        <div class="sample-order-body">
            <a-spin :spinning="loading">
                <div class="order-list">
                    <div class="order-item" v-for="item in list" :key="item.id">
                        <div class="order-info">
                            <div class="order-title">{{ item.sampleTypeName }}</div>
                            <div class="order-desc">{{ item.remark }}</div>
                        </div>
                        <div class="order-btn" @click="buy(item.id)">立即订购</div>
                    </div>
                </div>
            </a-spin>
            <a-pagination
                v-model="current"
                show-size-changer
                show-quick-jumper
                :page-size-options="pageSizeOptions"
                :total="total"
                :page-size="pageSize"
                @showSizeChange="onShowSizeChange"
            ></a-pagination>
        </div>
    </div>
</template>

<script>
import { getSampleTypeList, addSampleOrder } from '../../common/api';

export default {
    data() {
        return {
            list: [],
            searchKey: '',
            pageSizeOptions: ['10', '20', '30', '40', '50'],
            current: 1,
            pageSize: 10,
            total: 50,
            loading: false
        };
    },

    mounted() {
        this.getList();
        this.$emit('change', 'sampleOrder');
    },

    methods: {
        clear() {
            this.searchKey = '';
            this.getList();
        },

        async getList() {
            this.loading = true;
            const { data } = await getSampleTypeList({
                qf: { sampleTypeName_CISC: this.searchKey.trim() },
                n: this.current,
                s: this.pageSize
            });
            this.total = data.total;
            this.list = data.rows;
            this.loading = false;
        },

        async buy(sampleTypeId) {
            const { data } = await addSampleOrder(sampleTypeId);
            this.$router.push({ name: 'sampleMakeOrder', query: { id: data } });
        },

        onChange(pageNumber) {
            this.current = pageNumber;
            this.getList();
        },

        onShowSizeChange(current, pageSize) {
            this.current = current;
            this.pageSize = pageSize;
            this.getList();
        }
    }
};
</script>

<style lang="scss" scoped>
.sample-order {
    .subtitle {
        position: relative;
        opacity: 0.97;
        height: 56px;
        line-height: 56px;
        padding-left: 27px;
        font-size: 18px;
        color: #333333;
        font-weight: 600;
        display: flex;
        justify-content: space-between;
        padding-right: 24px;
        background: #ffffff;

        .sub-right {
            display: flex;
            align-items: center;

            .ant-input {
                width: 266px;
            }

            .ant-btn {
                margin-left: 16px;
            }
        }

        &::before {
            content: '';
            width: 3px;
            height: 18px;
            position: absolute;
            left: 16px;
            top: 50%;
            transform: translateY(-50%);
            background: #005299;
        }
    }
    &-body {
        margin-top: 16px;
        background: #ffffff;
        padding: 0 24px 24px;
        .order-list {
            margin-bottom: 24px;
        }
        .order-item {
            display: flex;
            justify-content: space-between;
            align-items: center;
            border-bottom: 1px solid #e2e2e2;
            padding: 20px 0 12px;

            .order-title {
                font-size: 16px;
                color: #005299;
                line-height: 26px;
                font-weight: 600;
                margin-bottom: 4px;
            }
            .order-desc {
                font-size: 14px;
                color: #666666;
                font-weight: 400;
            }

            .order-btn {
                width: 72px;
                height: 28px;
                border: 1px solid rgba(250, 100, 0, 1);
                border-radius: 2px;
                font-size: 14px;
                color: #fa6400;
                text-align: center;
                line-height: 28px;
                font-weight: 400;
                cursor: pointer;
            }
        }

        .ant-pagination {
            display: flex;
            justify-content: flex-end;
        }
    }
}
</style>
